<template>
    <div class="main">
        <div class="bg-wrp">
            <div class="color-face"></div>
        </div>
        <div class="login-wrp">
            <img class="logo-png" src="../assets/logo_tit@2x.png" alt="" srcset="" />
            <div class="login-inner">
                <h3>后台登录</h3>
                <div class="user input-wrp">
                    <span>
                        <img src="../assets/user.png" alt="" srcset="" />
                    </span>
                    <input type="text" placeholder="用户名或账号" v-model="name" />
                </div>
                <div class="passwd input-wrp">
                    <span>
                        <img src="../assets/password.png" alt="" srcset="" />
                    </span>
                    <input type="password" placeholder="密码" v-model="password" @keydown.enter="active_login" />
                </div>

                <el-button type="primary" @click="active_login">登录</el-button>
            </div>

        </div>
        <div class="copyrit">
            <a href="https://beian.miit.gov.cn/"> 浙ICP备2024058177号-3</a> &nbsp;&nbsp;&nbsp;
            <!-- <a href="http://www.beian.gov.cn/portal/registerSystemInfo"><img style="width:12px" src="../assets/gongan.png"> 浙公网安备 33038302330479号</a> -->
            <div>技术支持 浙江微在线网络科技有限公司</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            name: "",
            password: "",
            role: 0,
            type: ["insurancelogin", "login", "merchantlogin"],
        };
    },
    methods: {

        change_type() {
            sessionStorage.setItem("user_type", this.type[this.role]);
            console.log("role:", this.role);
            console.log("user_type:", sessionStorage.getItem("user_type"));
        },
        active_login() {
            let loginData = {
                name: this.name,
                password: this.password,
            }

            this.ipost(
                "/AdminAjax/login.ashx?type=login", loginData,
                (res) => {
                    console.log("res:", res);
                    sessionStorage.setItem("loginState", true);
                    this.$router.push({
                        path: "/policy"
                    });
                }
            );
        },
    },
};
</script>

<style scoped>
.mechant {
    color: #00a1e9;
}

.copyrit {
    font-size: 12px;
    color: #ddd;
    text-align: center;
    position: absolute;
    bottom: 6px;
    width: 100%;
    left: 0;
}

.copyrit a {
    color: #ddd;
}

.osys {
    display: flex;
    justify-content: center;
    align-items: center;
}

.osys a {
    display: inline-block;
    margin: 16px 6px;
    font-size: 13px;
    color: #999;
}

.main {
    min-width: 980px;
    position: relative;
    height: 100vh;
    width: 100%;
    background-color: #fdfdfd;
}

.bg-wrp {
    position: relative;
    width: 100%;
    height: 60%;
    background-image: url("../assets/laptop.jpg");
    background-size: 100% auto;
    background-position: center center;
    background-repeat: no-repeat;
}

.color-face {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.7);
}

.login-wrp {
    position: absolute;
    top: 41%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50%;
}

.logo-png {
    display: block;
    width: 370px;
    margin: 60px auto;
}

.login-inner {
    width: 47%;
    min-width: 330px;
    margin: 0 auto;
    padding: 10px;
    border-radius: 12px;
    background-color: #fff;
    box-shadow: 0 0 12px #ccc;
}

.login-inner h3 {
    text-align: center;
    color: #00a1e9;
}

.input-wrp {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 10px auto;
    border: 1px solid #efefef;
    border-radius: 4px;
}

.input-wrp span {
    padding: 0 12px;
    border-right: 1px solid #eee;
}

.input-wrp img {
    width: 16px;
}

.input-wrp input {
    box-sizing: border-box;
    padding-left: 10px;
    line-height: 31px;
    width: 90%;
}

.input-wrp input:focus {
    outline-color: #00a1e9;
}

.el-button {
    margin: 12px 1.5%;
    width: 97%;
}

.admswrp {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 8px;
}

.el-radio {
    margin: 0;
}

.copyright {
    color: #999;
    line-height: 1.8;
    text-align: center;
    font-size: 11px;
    position: absolute;
    bottom: 10px;
    left: 0;
    width: 100%;
}

.tips {
    width: 47%;
    margin: 6px auto;
}

.tips a {
    font-size: 12px;
    color: #666;
}
</style>
